import React, { useMemo } from 'react';

import {
  ColumnDef,
  ColumnOrderState,
  Updater,
  VisibilityState,
} from '@tanstack/react-table';

import { EntitlementsProject } from '@adsk/alloy-provider';
import { callOrReturn, useLocalState } from '@adsk/alloy-react-helpers';
import { TABLE_SIZES } from '@adsk/alloy-react-table';
import { TableSize } from '@adsk/alloy-react-table/es/types';

import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { ConfigurationHeader } from '../Columns/ConfigurationHeader';

export const useTableConfiguration = (enabled?: boolean) => {
  const [columnOrder, setColumnOrder] = useLocalState<ColumnOrderState>(
    LOCAL_STORAGE_KEYS.TableColumnOrder,
    [],
  );
  const [columnVisibility, setColumnVisibility] =
    useLocalState<VisibilityState>(
      LOCAL_STORAGE_KEYS.TableColumnVisibility,
      {},
    );
  const [tableSize, setTableSize] = useLocalState<TableSize>(
    LOCAL_STORAGE_KEYS.TableSize,
    TABLE_SIZES.LARGE,
  );

  const actionColumn = useMemo<ColumnDef<EntitlementsProject>>(
    () => ({
      id: 'actions',
      size: 10,
      minSize: 30,
      enableResizing: false,
      enableSorting: false,
      header: (headerProps) => (
        <ConfigurationHeader
          {...headerProps}
          tableSize={tableSize}
          setSize={setTableSize}
        />
      ),
    }),
    [setTableSize, tableSize],
  );

  return {
    tableSize,
    actionColumns: enabled ? [actionColumn] : [],
    columnState: enabled ? { columnVisibility, columnOrder } : {},
    columnOptions: enabled
      ? {
          onColumnVisibilityChange: (
            updaterOrValue: Updater<VisibilityState>,
          ) => {
            const newState = callOrReturn<Updater<VisibilityState>>(
              updaterOrValue,
              columnVisibility || {},
            );
            setColumnVisibility(newState);
            return newState;
          },
          onColumnOrderChange: (updaterOrValue: Updater<ColumnOrderState>) => {
            const newState = callOrReturn<Updater<ColumnOrderState>>(
              updaterOrValue,
              columnOrder || [],
            );
            setColumnOrder(newState);
            return newState;
          },
        }
      : {},
  };
};
